module.exports = __webpack_public_path__ + "static/img/hb_21-min.d64d34a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_21-min.png
// module id = vUeO
// module chunks = 1